import { render } from "./BaseSkeleton.vue?vue&type=template&id=1532fc1b&scoped=true"
import script from "./BaseSkeleton.vue?vue&type=script&lang=js"
export * from "./BaseSkeleton.vue?vue&type=script&lang=js"

import "./BaseSkeleton.vue?vue&type=style&index=0&id=1532fc1b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1532fc1b"]])

export default __exports__